import { render } from "./EditDependent.vue?vue&type=template&id=fd8f5d00"
import script from "./EditDependent.vue?vue&type=script&lang=js"
export * from "./EditDependent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__